// Firebase Remote Config lets us change app behavior (e.g. the PDF password)
// without redeploying. Values are set in the Firebase console and fetched at
// app startup via initRemoteConfig(). getConfigValue() is then used to read
// individual keys throughout the app.

import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../config/firebase';

// Cache remote config for 1 hour before re-fetching from Firebase
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

// Call once at app startup to fetch and activate the latest remote config values
export const initRemoteConfig = () => fetchAndActivate(remoteConfig);

// Read a remote config value by key as a string.
// Uses the public .asString() API — do not use ._value (internal Firebase property)
export const getConfigValue = (key) => getValue(remoteConfig, key).asString();
